var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 142,
    height: 116,
    viewBox: "0 0 142 116",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M57.6406 89.571C72.2846 77.6413 83.1956 61.758 89.0769 43.8087C93.9359 29.7492 95.6379 14.7918 94.0618 0L140.588 26.7658C142.024 41.3163 140.309 56.0057 135.558 69.8335C129.606 87.9994 118.496 104.041 103.583 116L57.6406 89.571Z",
    fill: "url(#paint0_linear_9094_235472)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.06427 57.7306C9.42838 40.9696 20.7054 26.7317 35.7925 17.6718L70.6419 37.7236C55.6932 46.7764 44.5266 60.9341 39.2056 77.5804C36.911 84.2874 35.5362 91.2745 35.1189 98.3508V98.3508L0 78.1642C0.45423 71.2044 1.82067 64.3345 4.06427 57.7306V57.7306Z",
    fill: "url(#paint1_linear_9094_235472)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_9094_235472",
    x1: 99.3836,
    y1: 88.2013,
    x2: 99.3836,
    y2: 23.3751,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0C6DEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#069EB5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00CD80"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_9094_235472",
    x1: 35.3209,
    y1: 89.3465,
    x2: 35.3209,
    y2: 20.2091,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0C6DEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#069EB5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00CD80"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.ee3d49bc414bade7d4fed58486492957.svg";
export { ForwardRef as ReactComponent };